export const AUTH_FLOW_PREFIX = '[AUTH-FLOW]';

let step = 0;
let previousAt = 0;

export function resetAuthFlowLog(): void {
  step = 0;
  previousAt = 0;
}

export function authFlowLog(
  debug: boolean,
  stepName: string,
  detail?: Record<string, unknown>
): void {
  if (!debug) {
    return;
  }

  step += 1;
  const now = Date.now();
  const sincePreviousMs = previousAt === 0 ? 0 : now - previousAt;
  previousAt = now;

  console.log(`${AUTH_FLOW_PREFIX} ${step}. ${stepName}`, {
    sincePreviousMs,
    ...detail,
  });
}
